// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700&family=Manrope:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

* {
    border-color: var(--border);
  }

body {
    background-color: var(--bg);
    color: var(--text-primary);
    font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

h1, h2, h3, h4, h5, h6 {
    font-family: 'Manrope', sans-serif;
    color: var(--text-primary);
    line-height: 1.3;
  }

h1 { font-size: 1.875rem; font-weight: 700; }

h2 { font-size: 1.5rem; font-weight: 700; }

h3 { font-size: 1.25rem; font-weight: 600; }

h4 { font-size: 1.125rem; font-weight: 600; }

/* Responsive headings for smaller screens */

@media (max-width: 1366px) {
    h1 { font-size: 1.625rem; }
    h2 { font-size: 1.375rem; }
    h3 { font-size: 1.125rem; }
  }

[data-debug-wrapper="true"] { display: contents !important; }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-right-3{
  right: -0.75rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.-top-3{
  top: -0.75rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-36{
  bottom: 9rem;
}
.bottom-4{
  bottom: 1rem;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-6{
  right: 1.5rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-4{
  top: 1rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-7{
  grid-column: span 7 / span 7;
}
.col-span-8{
  grid-column: span 8 / span 8;
}
.-m-4{
  margin: -1rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-14{
  margin-left: 3.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.table-cell{
  display: table-cell;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[calc\\(100vh-0px\\)\\]{
  height: calc(100vh - 0px);
}
.h-\\[calc\\(100vh-64px\\)\\]{
  height: calc(100vh - 64px);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-28{
  max-height: 7rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[350px\\]{
  max-height: 350px;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[88vh\\]{
  max-height: 88vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[850px\\]{
  max-width: 850px;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-screen-xl{
  max-width: 1280px;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.table-fixed{
  table-layout: fixed;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#2D3F5E\\]\\/30 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(45 63 94 / 0.3);
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-l-md{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-r-md{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-\\[3px\\]{
  border-left-width: 3px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#0F172A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2D3748\\]{
  --tw-border-opacity: 1;
  border-color: rgb(45 55 72 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2D3748\\]\\/40{
  border-color: rgb(45 55 72 / 0.4);
}
.border-\\[\\#2D3748\\]\\/60{
  border-color: rgb(45 55 72 / 0.6);
}
.border-\\[\\#2D3F5E\\]{
  --tw-border-opacity: 1;
  border-color: rgb(45 63 94 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2D3F5E\\]\\/20{
  border-color: rgb(45 63 94 / 0.2);
}
.border-\\[\\#2D3F5E\\]\\/30{
  border-color: rgb(45 63 94 / 0.3);
}
.border-\\[\\#2D3F5E\\]\\/40{
  border-color: rgb(45 63 94 / 0.4);
}
.border-\\[\\#2D3F5E\\]\\/50{
  border-color: rgb(45 63 94 / 0.5);
}
.border-\\[\\#2D3F5E\\]\\/60{
  border-color: rgb(45 63 94 / 0.6);
}
.border-\\[\\#3B82F6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3B82F6\\]\\/20{
  border-color: rgb(59 130 246 / 0.2);
}
.border-\\[\\#3B82F6\\]\\/25{
  border-color: rgb(59 130 246 / 0.25);
}
.border-\\[\\#3B82F6\\]\\/30{
  border-color: rgb(59 130 246 / 0.3);
}
.border-\\[\\#3B82F6\\]\\/40{
  border-color: rgb(59 130 246 / 0.4);
}
.border-\\[\\#57EB31\\]{
  --tw-border-opacity: 1;
  border-color: rgb(87 235 49 / var(--tw-border-opacity, 1));
}
.border-\\[\\#57EB31\\]\\/20{
  border-color: rgb(87 235 49 / 0.2);
}
.border-\\[\\#57EB31\\]\\/30{
  border-color: rgb(87 235 49 / 0.3);
}
.border-\\[\\#57EB31\\]\\/40{
  border-color: rgb(87 235 49 / 0.4);
}
.border-\\[\\#8B5CF6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8B5CF6\\]\\/30{
  border-color: rgb(139 92 246 / 0.3);
}
.border-\\[\\#9333EA\\]\\/40{
  border-color: rgb(147 51 234 / 0.4);
}
.border-\\[\\#F59E0B\\]{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F59E0B\\]\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-\\[\\#F59E0B\\]\\/40{
  border-color: rgb(245 158 11 / 0.4);
}
.border-\\[\\#ddd\\]{
  --tw-border-opacity: 1;
  border-color: rgb(221 221 221 / var(--tw-border-opacity, 1));
}
.border-\\[var\\(--border\\)\\]{
  border-color: var(--border);
}
.border-\\[var\\(--error\\)\\]{
  border-color: var(--error);
}
.border-\\[var\\(--primary\\)\\]{
  border-color: var(--primary);
}
.border-\\[var\\(--success\\)\\]{
  border-color: var(--success);
}
.border-\\[var\\(--warning\\)\\]{
  border-color: var(--warning);
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-500\\/40{
  border-color: rgb(245 158 11 / 0.4);
}
.border-amber-600\\/50{
  border-color: rgb(217 119 6 / 0.5);
}
.border-amber-700\\/50{
  border-color: rgb(180 83 9 / 0.5);
}
.border-amber-800\\/50{
  border-color: rgb(146 64 14 / 0.5);
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-700\\/50{
  border-color: rgb(29 78 216 / 0.5);
}
.border-blue-800\\/30{
  border-color: rgb(30 64 175 / 0.3);
}
.border-blue-800\\/40{
  border-color: rgb(30 64 175 / 0.4);
}
.border-blue-800\\/50{
  border-color: rgb(30 64 175 / 0.5);
}
.border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.border-cyan-700\\/50{
  border-color: rgb(14 116 144 / 0.5);
}
.border-cyan-800\\/50{
  border-color: rgb(21 94 117 / 0.5);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-700\\/50{
  border-color: rgb(4 120 87 / 0.5);
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-700\\/50{
  border-color: rgb(55 65 81 / 0.5);
}
.border-green-700\\/50{
  border-color: rgb(21 128 61 / 0.5);
}
.border-green-800\\/50{
  border-color: rgb(22 101 52 / 0.5);
}
.border-indigo-800\\/50{
  border-color: rgb(55 48 163 / 0.5);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-orange-500\\/40{
  border-color: rgb(249 115 22 / 0.4);
}
.border-orange-700\\/50{
  border-color: rgb(194 65 12 / 0.5);
}
.border-orange-800\\/50{
  border-color: rgb(154 52 18 / 0.5);
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-purple-800\\/50{
  border-color: rgb(107 33 168 / 0.5);
}
.border-red-400\\/30{
  border-color: rgb(248 113 113 / 0.3);
}
.border-red-500\\/30{
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-500\\/40{
  border-color: rgb(239 68 68 / 0.4);
}
.border-red-700\\/50{
  border-color: rgb(185 28 28 / 0.5);
}
.border-red-800{
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.border-red-800\\/40{
  border-color: rgb(153 27 27 / 0.4);
}
.border-red-800\\/50{
  border-color: rgb(153 27 27 / 0.5);
}
.border-sky-800\\/50{
  border-color: rgb(7 89 133 / 0.5);
}
.border-slate-500{
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/50{
  border-color: rgb(51 65 85 / 0.5);
}
.border-teal-700\\/50{
  border-color: rgb(15 118 110 / 0.5);
}
.border-teal-800\\/50{
  border-color: rgb(17 94 89 / 0.5);
}
.border-transparent{
  border-color: transparent;
}
.border-violet-500{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/40{
  border-color: rgb(139 92 246 / 0.4);
}
.border-violet-700\\/50{
  border-color: rgb(109 40 217 / 0.5);
}
.border-yellow-800\\/50{
  border-color: rgb(133 77 14 / 0.5);
}
.border-l-\\[\\#3B82F6\\]{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#57EB31\\]{
  --tw-border-opacity: 1;
  border-left-color: rgb(87 235 49 / var(--tw-border-opacity, 1));
}
.border-l-teal-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#0A0D10\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 13 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0A0D12\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 13 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0A0F1A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 15 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0D1117\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 17 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0D1117\\]\\/90{
  background-color: rgb(13 17 23 / 0.9);
}
.bg-\\[\\#0E0905\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 9 5 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F1419\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 20 25 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F172A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#140E0A\\]\\/95{
  background-color: rgb(20 14 10 / 0.95);
}
.bg-\\[\\#161B22\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 27 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A2028\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 32 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A2332\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 35 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1C2432\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 36 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E293B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22C55E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#232B35\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(35 43 53 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#242D38\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(36 45 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2D3F5E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(45 63 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2D3F5E\\]\\/20{
  background-color: rgb(45 63 94 / 0.2);
}
.bg-\\[\\#3B82F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3B82F6\\]\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-\\[\\#3B82F6\\]\\/15{
  background-color: rgb(59 130 246 / 0.15);
}
.bg-\\[\\#3B82F6\\]\\/5{
  background-color: rgb(59 130 246 / 0.05);
}
.bg-\\[\\#57EB31\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(87 235 49 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#57EB31\\]\\/10{
  background-color: rgb(87 235 49 / 0.1);
}
.bg-\\[\\#57EB31\\]\\/5{
  background-color: rgb(87 235 49 / 0.05);
}
.bg-\\[\\#57EB31\\]\\/50{
  background-color: rgb(87 235 49 / 0.5);
}
.bg-\\[\\#5C6A7A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(92 106 122 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7B8EA2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(123 142 162 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8B5CF6\\]\\/10{
  background-color: rgb(139 92 246 / 0.1);
}
.bg-\\[\\#9333EA\\]\\/20{
  background-color: rgb(147 51 234 / 0.2);
}
.bg-\\[\\#F59E0B\\]\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-\\[var\\(--bg-darker\\)\\]{
  background-color: var(--bg-darker);
}
.bg-\\[var\\(--error\\)\\]{
  background-color: var(--error);
}
.bg-\\[var\\(--error-muted\\)\\]{
  background-color: var(--error-muted);
}
.bg-\\[var\\(--primary\\)\\]{
  background-color: var(--primary);
}
.bg-\\[var\\(--primary-muted\\)\\]{
  background-color: var(--primary-muted);
}
.bg-\\[var\\(--success\\)\\]{
  background-color: var(--success);
}
.bg-\\[var\\(--success-muted\\)\\]{
  background-color: var(--success-muted);
}
.bg-\\[var\\(--surface\\)\\]{
  background-color: var(--surface);
}
.bg-\\[var\\(--warning\\)\\]{
  background-color: var(--warning);
}
.bg-\\[var\\(--warning-muted\\)\\]{
  background-color: var(--warning-muted);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2);
}
.bg-amber-500\\/5{
  background-color: rgb(245 158 11 / 0.05);
}
.bg-amber-900\\/20{
  background-color: rgb(120 53 15 / 0.2);
}
.bg-amber-900\\/30{
  background-color: rgb(120 53 15 / 0.3);
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-500\\/20{
  background-color: rgb(59 130 246 / 0.2);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-900\\/10{
  background-color: rgb(30 58 138 / 0.1);
}
.bg-blue-900\\/20{
  background-color: rgb(30 58 138 / 0.2);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-900\\/20{
  background-color: rgb(22 78 99 / 0.2);
}
.bg-cyan-900\\/30{
  background-color: rgb(22 78 99 / 0.3);
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-900\\/20{
  background-color: rgb(6 78 59 / 0.2);
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500\\/20{
  background-color: rgb(107 114 128 / 0.2);
}
.bg-gray-900\\/20{
  background-color: rgb(17 24 39 / 0.2);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/15{
  background-color: rgb(34 197 94 / 0.15);
}
.bg-green-500\\/20{
  background-color: rgb(34 197 94 / 0.2);
}
.bg-green-900\\/30{
  background-color: rgb(20 83 45 / 0.3);
}
.bg-green-900\\/40{
  background-color: rgb(20 83 45 / 0.4);
}
.bg-indigo-900\\/20{
  background-color: rgb(49 46 129 / 0.2);
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10{
  background-color: rgb(249 115 22 / 0.1);
}
.bg-orange-500\\/20{
  background-color: rgb(249 115 22 / 0.2);
}
.bg-orange-900\\/10{
  background-color: rgb(124 45 18 / 0.1);
}
.bg-orange-900\\/20{
  background-color: rgb(124 45 18 / 0.2);
}
.bg-orange-900\\/30{
  background-color: rgb(124 45 18 / 0.3);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-500\\/20{
  background-color: rgb(168 85 247 / 0.2);
}
.bg-purple-900\\/20{
  background-color: rgb(88 28 135 / 0.2);
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-400\\/20{
  background-color: rgb(248 113 113 / 0.2);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/15{
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-500\\/20{
  background-color: rgb(239 68 68 / 0.2);
}
.bg-red-500\\/5{
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-500\\/50{
  background-color: rgb(239 68 68 / 0.5);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-900\\/20{
  background-color: rgb(127 29 29 / 0.2);
}
.bg-red-900\\/30{
  background-color: rgb(127 29 29 / 0.3);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-sky-900\\/20{
  background-color: rgb(12 74 110 / 0.2);
}
.bg-slate-800\\/40{
  background-color: rgb(30 41 59 / 0.4);
}
.bg-slate-900\\/20{
  background-color: rgb(15 23 42 / 0.2);
}
.bg-teal-400{
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}
.bg-teal-900\\/10{
  background-color: rgb(19 78 74 / 0.1);
}
.bg-teal-900\\/20{
  background-color: rgb(19 78 74 / 0.2);
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-500\\/10{
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-900\\/20{
  background-color: rgb(76 29 149 / 0.2);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/20{
  background-color: rgb(234 179 8 / 0.2);
}
.bg-yellow-900\\/20{
  background-color: rgb(113 63 18 / 0.2);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.from-\\[\\#57EB31\\]\\/5{
  --tw-gradient-from: rgb(87 235 49 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(87 235 49 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-12{
  padding: 3rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32{
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-\\[\\'Helvetica\\'\\]{
  font-family: 'Helvetica';
}
.font-\\[\\'IBM_Plex_Sans\\'\\]{
  font-family: 'IBM Plex Sans';
}
.font-\\[\\'JetBrains_Mono\\'\\]{
  font-family: 'JetBrains Mono';
}
.font-\\[\\'Manrope\\'\\]{
  font-family: 'Manrope';
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[7px\\]{
  font-size: 7px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#0A0F1A\\]{
  --tw-text-opacity: 1;
  color: rgb(10 15 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#10B981\\]{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#22C55E\\]{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2D3748\\]{
  --tw-text-opacity: 1;
  color: rgb(45 55 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2D3F5E\\]{
  --tw-text-opacity: 1;
  color: rgb(45 63 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3B82F6\\]{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3B82F6\\]\\/70{
  color: rgb(59 130 246 / 0.7);
}
.text-\\[\\#3D4A5C\\]{
  --tw-text-opacity: 1;
  color: rgb(61 74 92 / var(--tw-text-opacity, 1));
}
.text-\\[\\#555\\]{
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#57EB31\\]{
  --tw-text-opacity: 1;
  color: rgb(87 235 49 / var(--tw-text-opacity, 1));
}
.text-\\[\\#57EB31\\]\\/70{
  color: rgb(87 235 49 / 0.7);
}
.text-\\[\\#5C6A7A\\]{
  --tw-text-opacity: 1;
  color: rgb(92 106 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5C6A7A\\]\\/60{
  color: rgb(92 106 122 / 0.6);
}
.text-\\[\\#7B8EA2\\]{
  --tw-text-opacity: 1;
  color: rgb(123 142 162 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A94A6\\]{
  --tw-text-opacity: 1;
  color: rgb(138 148 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8B5CF6\\]{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8B9AAB\\]{
  --tw-text-opacity: 1;
  color: rgb(139 154 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9333EA\\]{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-\\[\\#999\\]{
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B8C0CC\\]{
  --tw-text-opacity: 1;
  color: rgb(184 192 204 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C084FC\\]{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C8D4E0\\]{
  --tw-text-opacity: 1;
  color: rgb(200 212 224 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C9C3BD\\]{
  --tw-text-opacity: 1;
  color: rgb(201 195 189 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E8EAED\\]{
  --tw-text-opacity: 1;
  color: rgb(232 234 237 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F59E0B\\]{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--error\\)\\]{
  color: var(--error);
}
.text-\\[var\\(--primary\\)\\]{
  color: var(--primary);
}
.text-\\[var\\(--success\\)\\]{
  color: var(--success);
}
.text-\\[var\\(--text-faint\\)\\]{
  color: var(--text-faint);
}
.text-\\[var\\(--text-muted\\)\\]{
  color: var(--text-muted);
}
.text-\\[var\\(--warning\\)\\]{
  color: var(--warning);
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-blue-300{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-cyan-200{
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.text-cyan-300{
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-cyan-400{
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-300{
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-300{
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-400\\/70{
  color: rgb(248 113 113 / 0.7);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-400{
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-teal-300{
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}
.text-teal-400{
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-\\[\\#5C6A7A\\]::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(92 106 122 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#3B82F6\\]{
  accent-color: #3B82F6;
}
.accent-\\[var\\(--primary\\)\\]{
  accent-color: var(--primary);
}
.accent-yellow-500{
  accent-color: #eab308;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 0 20px rgba(59,130,246,0.2);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 0 20px rgba(59,130,246,0.25);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_25px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 0 25px rgba(59,130,246,0.4);
  --tw-shadow-colored: 0 0 25px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_30px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 0 30px rgba(59,130,246,0.2);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[var\\(--primary\\)\\]{
  --tw-ring-color: var(--primary);
}
.ring-red-500\\/40{
  --tw-ring-color: rgb(239 68 68 / 0.4);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.duration-700{
  animation-duration: 700ms;
}
.ease-in{
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}

/* ═══════════════════════════════════════════════════════════════════════════
   THEME TOKENS - Slate Industrial (Option A)
   ═══════════════════════════════════════════════════════════════════════════ */

:root {
  /* Core Colors */
  --bg: #0F1419;
  --bg-darker: #0A0D10;
  --surface: #1A2028;
  --surface-hover: #232B35;
  --surface-elevated: #242D38;
  --border: #2D3748;
  --border-light: #3D4A5C;
  
  /* Text — tuned for legibility on dark backgrounds */
  --text-primary: #E8EAED;
  --text-secondary: #C8D4E0;
  --text-muted: #9BAFC0;
  --text-faint: #7B8EA2;
  
  /* Primary Accent (Blue) */
  --primary: #3B82F6;
  --primary-hover: #2563EB;
  --primary-muted: rgba(59, 130, 246, 0.15);
  --primary-text: #FFFFFF;
  
  /* Status Colors */
  --success: #22C55E;
  --success-muted: rgba(34, 197, 94, 0.15);
  --warning: #F59E0B;
  --warning-muted: rgba(245, 158, 11, 0.15);
  --error: #EF4444;
  --error-muted: rgba(239, 68, 68, 0.15);
  --info: #3B82F6;
  --info-muted: rgba(59, 130, 246, 0.15);
  
  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.5);
  
  /* Border Radius */
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  
  /* Responsive Base Font Size */
  --base-font: 16px;
  
  /* Shadcn tokens (mapped to our theme) */
  --background: 210 22% 8%;
  --foreground: 220 10% 92%;
  --card: 215 20% 13%;
  --card-foreground: 220 10% 92%;
  --popover: 215 20% 13%;
  --popover-foreground: 220 10% 92%;
  --primary-hsl: 217 91% 60%;
  --primary-foreground: 0 0% 100%;
  --secondary: 215 20% 18%;
  --secondary-foreground: 217 91% 60%;
  --muted: 215 15% 15%;
  --muted-foreground: 215 20% 68%;
  --accent: 215 20% 18%;
  --accent-foreground: 217 91% 60%;
  --destructive: 0 72% 51%;
  --destructive-foreground: 0 0% 98%;
  --border-hsl: 215 20% 25%;
  --input: 215 20% 25%;
  --ring: 217 91% 60%;
  --radius: 0.375rem;
}

/* ═══════════════════════════════════════════════════════════════════════════
   RESPONSIVE TYPOGRAPHY & SPACING
   ═══════════════════════════════════════════════════════════════════════════ */

html {
  font-size: var(--base-font);
}

/* Small laptops (1366x768 and below) */
@media (max-width: 1366px) {
  :root {
    --base-font: 15px;
  }
}

/* Larger screens */
@media (min-width: 1920px) {
  :root {
    --base-font: 17px;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   COMPONENT STYLES
   ═══════════════════════════════════════════════════════════════════════════ */

/* Cards */
.card-slate {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.card-slate:hover {
  border-color: var(--border-light);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.55), 0 0 0 1px var(--border-light);
  transform: translateY(-1px);
}

/* Legacy support - map old class to new */
.card-industrial {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.card-industrial:hover {
  border-color: var(--primary);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5), 0 0 12px rgba(59, 130, 246, 0.1);
}

/* Buttons */
.btn-primary {
  background: var(--primary);
  color: var(--primary-text);
  font-weight: 600;
  padding: 0.75rem 1.25rem;
  min-height: 44px;
  border-radius: var(--radius-md);
  transition: background 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;
}

.btn-primary:hover {
  background: var(--primary-hover);
  box-shadow: 0 0 18px rgba(59, 130, 246, 0.5), 0 4px 12px rgba(0, 0, 0, 0.3);
}

.btn-primary:active {
  transform: scale(0.98);
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.3);
}

/* Status Strips */
.strip-emergency { border-left: 4px solid var(--error); }
.strip-high { border-left: 4px solid var(--warning); }
.strip-medium { border-left: 4px solid var(--primary); }
.strip-low { border-left: 4px solid var(--border); }

/* Status Badges */
.badge-success {
  background: var(--success-muted);
  color: var(--success);
  border: 1px solid var(--success);
  box-shadow: 0 0 8px rgba(87, 235, 49, 0.18);
}

.badge-warning {
  background: var(--warning-muted);
  color: var(--warning);
  border: 1px solid var(--warning);
  box-shadow: 0 0 8px rgba(245, 158, 11, 0.18);
}

.badge-error {
  background: var(--error-muted);
  color: var(--error);
  border: 1px solid var(--error);
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.18);
}

.badge-info {
  background: var(--info-muted);
  color: var(--info);
  border: 1px solid var(--info);
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.18);
}

/* ═══════════════════════════════════════════════════════════════════════════
   TABLE STYLES (Comfortable by Default)
   ═══════════════════════════════════════════════════════════════════════════ */

.table-comfortable th {
  padding: 1rem 1.25rem;
  font-size: 0.76rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  background: var(--bg-darker);
  border-bottom: 1px solid var(--border);
  text-align: left;
}

.table-comfortable td {
  padding: 1rem 1.25rem;
  font-size: 0.9375rem;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
  transition: background 0.12s ease, box-shadow 0.12s ease;
  text-align: left;
  vertical-align: middle;
}

/* Right-align numeric columns when explicitly tagged */
.table-comfortable th.num,
.table-comfortable td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* Center-align utility (e.g. status pills) */
.table-comfortable th.center,
.table-comfortable td.center {
  text-align: center;
}

.table-comfortable tbody tr:hover td {
  background: var(--surface-hover);
}

.table-comfortable tbody tr:hover td:first-child {
  box-shadow: inset 2px 0 0 var(--primary);
}

/* Compact variant (optional) */
.table-compact th {
  padding: 0.625rem 1rem;
  font-size: 0.7rem;
  color: var(--text-secondary);
  text-align: left;
}

.table-compact td {
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
  text-align: left;
  vertical-align: middle;
}

/* ═══════════════════════════════════════════════════════════════════════════
   FORM ELEMENTS
   ═══════════════════════════════════════════════════════════════════════════ */

.input-slate {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 0.75rem 1rem;
  min-height: 44px;
  font-size: 0.9375rem;
  color: var(--text-primary);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input-slate:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-muted);
}

.input-slate::placeholder {
  color: var(--text-faint);
}

/* Select */
.select-slate {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 0.75rem 1rem;
  min-height: 44px;
  font-size: 0.9375rem;
  color: var(--text-primary);
}

.select-slate:focus {
  outline: none;
  border-color: var(--primary);
}

/* ═══════════════════════════════════════════════════════════════════════════
   SCROLLBAR
   ═══════════════════════════════════════════════════════════════════════════ */

/* Pulse ring — for alert/overdue cards */
@keyframes ring-pulse-error {
  0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5), 0 4px 16px rgba(0,0,0,0.4); }
  60%       { box-shadow: 0 0 0 7px rgba(239, 68, 68, 0), 0 4px 16px rgba(0,0,0,0.4); }
}
@keyframes ring-pulse-warning {
  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.45), 0 4px 16px rgba(0,0,0,0.4); }
  60%       { box-shadow: 0 0 0 7px rgba(245, 158, 11, 0), 0 4px 16px rgba(0,0,0,0.4); }
}
.ring-pulse-error   { animation: ring-pulse-error   2.2s ease-in-out infinite; }
.ring-pulse-warning { animation: ring-pulse-warning 2.2s ease-in-out infinite; }

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-darker);
}

::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--border-light);
}

/* ═══════════════════════════════════════════════════════════════════════════
   ANIMATIONS
   ═══════════════════════════════════════════════════════════════════════════ */

@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes pulseError {
  0%, 100% { border-left-color: var(--error); box-shadow: -3px 0 8px rgba(239, 68, 68, 0.3); }
  50% { border-left-color: rgba(239, 68, 68, 0.4); box-shadow: none; }
}

.animate-fade-slide-in { animation: fadeSlideIn 0.35s ease-out forwards; }
.animate-fade-in { animation: fadeIn 0.25s ease-out forwards; }
.live-dot { animation: pulse 2s ease-in-out infinite; }
.emergency-strip { animation: pulseError 1.8s ease-in-out infinite; }

/* PWA Install Prompt */
@keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
.animate-slide-up { animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

/* ═══════════════════════════════════════════════════════════════════════════
   LOGIN PAGE ANIMATIONS
   ═══════════════════════════════════════════════════════════════════════════ */

@keyframes tireRotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
@keyframes tireRotateRev { from { transform: rotate(0deg); } to { transform: rotate(-360deg); } }
@keyframes lightSweep {
  0% { transform: rotate(0deg); opacity: 0; }
  5% { opacity: 1; }
  18% { opacity: 0; }
  100% { transform: rotate(360deg); opacity: 0; }
}
@keyframes grainFloat {
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  15% { opacity: 0.6; }
  85% { opacity: 0.2; }
  100% { transform: translateY(-80px) translateX(20px); opacity: 0; }
}
@keyframes cardReveal {
  from { opacity: 0; transform: translateX(24px); }
  to { opacity: 1; transform: translateX(0); }
}
@keyframes hubGlow {
  0%, 100% { filter: drop-shadow(0 0 0 rgba(59, 130, 246, 0)); }
  50% { filter: drop-shadow(0 0 25px rgba(59, 130, 246, 0.3)); }
}

.tire-spin { animation: tireRotate 30s linear infinite; }
.tire-spin-rev { animation: tireRotateRev 80s linear infinite; }
.light-sweep-anim { animation: lightSweep 7s ease-in-out infinite; }
.card-reveal { animation: cardReveal 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
.hub-glow { animation: hubGlow 4s ease-in-out infinite; }

@media (prefers-reduced-motion: reduce) {
  .tire-spin, .tire-spin-rev, .light-sweep-anim, .live-dot, .emergency-strip {
    animation: none !important;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   UTILITY CLASSES
   ═══════════════════════════════════════════════════════════════════════════ */

.text-primary-accent { color: var(--primary); }
.text-success { color: var(--success); }
.text-warning { color: var(--warning); }
.text-error { color: var(--error); }
.text-muted { color: var(--text-muted); }

.bg-surface { background-color: var(--surface); }
.bg-surface-elevated { background-color: var(--surface-elevated); }

.border-default { border-color: var(--border); }
.border-light { border-color: var(--border-light); }

/* Focus ring utility */
.focus-ring:focus {
  outline: none;
  box-shadow: 0 0 0 3px var(--primary-muted);
}

/* ═══════════════════════════════════════════════════════════════════════════
   RESPONSIVE SPACING UTILITIES
   ═══════════════════════════════════════════════════════════════════════════ */

.page-padding {
  padding: 1.5rem;
}

@media (min-width: 1280px) {
  .page-padding {
    padding: 2rem;
  }
}

@media (min-width: 1536px) {
  .page-padding {
    padding: 2.5rem;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   DEBUG WRAPPER (keep for compatibility)
   ═══════════════════════════════════════════════════════════════════════════ */

.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}

.file\\:cursor-pointer::file-selector-button{
  cursor: pointer;
}

.file\\:rounded-sm::file-selector-button{
  border-radius: calc(var(--radius) - 4px);
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-\\[\\#3B82F6\\]::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.file\\:py-2::file-selector-button{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.file\\:text-\\[10px\\]::file-selector-button{
  font-size: 10px;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-bold::file-selector-button{
  font-weight: 700;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:uppercase::file-selector-button{
  text-transform: uppercase;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}

.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.focus-within\\:relative:focus-within{
  position: relative;
}

.focus-within\\:z-20:focus-within{
  z-index: 20;
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-0\\.5:hover{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#2D3F5E\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(45 63 94 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#3B82F6\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#3B82F6\\]\\/40:hover{
  border-color: rgb(59 130 246 / 0.4);
}

.hover\\:border-\\[\\#3B82F6\\]\\/50:hover{
  border-color: rgb(59 130 246 / 0.5);
}

.hover\\:border-\\[\\#3B82F6\\]\\/70:hover{
  border-color: rgb(59 130 246 / 0.7);
}

.hover\\:border-\\[\\#57EB31\\]\\/70:hover{
  border-color: rgb(87 235 49 / 0.7);
}

.hover\\:border-\\[\\#9333EA\\]\\/70:hover{
  border-color: rgb(147 51 234 / 0.7);
}

.hover\\:border-\\[var\\(--primary\\)\\]:hover{
  border-color: var(--primary);
}

.hover\\:border-red-800\\/50:hover{
  border-color: rgb(153 27 27 / 0.5);
}

.hover\\:bg-\\[\\#0A0F1A\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(10 15 26 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0A0F1A\\]\\/60:hover{
  background-color: rgb(10 15 26 / 0.6);
}

.hover\\:bg-\\[\\#161B22\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 27 34 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1A2332\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(26 35 50 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#232B35\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(35 43 53 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#2563EB\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#2A1C14\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(42 28 20 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#2D3F5E\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(45 63 94 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#3B82F6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#3B82F6\\]\\/10:hover{
  background-color: rgb(59 130 246 / 0.1);
}

.hover\\:bg-\\[\\#3B82F6\\]\\/20:hover{
  background-color: rgb(59 130 246 / 0.2);
}

.hover\\:bg-\\[\\#3B82F6\\]\\/5:hover{
  background-color: rgb(59 130 246 / 0.05);
}

.hover\\:bg-\\[\\#3B82F6\\]\\/90:hover{
  background-color: rgb(59 130 246 / 0.9);
}

.hover\\:bg-\\[\\#46c027\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(70 192 39 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#57EB31\\]\\/10:hover{
  background-color: rgb(87 235 49 / 0.1);
}

.hover\\:bg-\\[\\#57EB31\\]\\/20:hover{
  background-color: rgb(87 235 49 / 0.2);
}

.hover\\:bg-\\[\\#57EB31\\]\\/90:hover{
  background-color: rgb(87 235 49 / 0.9);
}

.hover\\:bg-\\[\\#F59E0B\\]\\/10:hover{
  background-color: rgb(245 158 11 / 0.1);
}

.hover\\:bg-\\[var\\(--bg-darker\\)\\]:hover{
  background-color: var(--bg-darker);
}

.hover\\:bg-\\[var\\(--primary-muted\\)\\]:hover{
  background-color: var(--primary-muted);
}

.hover\\:bg-\\[var\\(--success-muted\\)\\]:hover{
  background-color: var(--success-muted);
}

.hover\\:bg-\\[var\\(--surface\\)\\]:hover{
  background-color: var(--surface);
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-amber-500\\/20:hover{
  background-color: rgb(245 158 11 / 0.2);
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-900\\/20:hover{
  background-color: rgb(30 58 138 / 0.2);
}

.hover\\:bg-cyan-900\\/50:hover{
  background-color: rgb(22 78 99 / 0.5);
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-green-900\\/60:hover{
  background-color: rgb(20 83 45 / 0.6);
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-red-400\\/10:hover{
  background-color: rgb(248 113 113 / 0.1);
}

.hover\\:bg-red-500\\/20:hover{
  background-color: rgb(239 68 68 / 0.2);
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-900\\/20:hover{
  background-color: rgb(127 29 29 / 0.2);
}

.hover\\:bg-red-900\\/30:hover{
  background-color: rgb(127 29 29 / 0.3);
}

.hover\\:bg-red-900\\/50:hover{
  background-color: rgb(127 29 29 / 0.5);
}

.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-violet-500\\/20:hover{
  background-color: rgb(139 92 246 / 0.2);
}

.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:text-\\[\\#3B82F6\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#3B82F6\\]\\/80:hover{
  color: rgb(59 130 246 / 0.8);
}

.hover\\:text-\\[\\#B8C0CC\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(184 192 204 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#E8EAED\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(232 234 237 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[var\\(--primary\\)\\]:hover{
  color: var(--primary);
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-cyan-300:hover{
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}

.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}

.hover\\:text-red-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:shadow-2xl:hover{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-\\[\\#3B82F6\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#57EB31\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(87 235 49 / var(--tw-border-opacity, 1));
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[var\\(--primary\\)\\]:focus{
  --tw-ring-color: var(--primary);
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active{
  cursor: grabbing;
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-20:disabled{
  opacity: 0.2;
}

.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.group:hover .group-hover\\:text-\\[\\#3B82F6\\]{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-\\[\\#57EB31\\]{
  --tw-text-opacity: 1;
  color: rgb(87 235 49 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}

.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}

.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}

@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:table-cell{
    display: table-cell;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:w-96{
    width: 24rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:table-cell{
    display: table-cell;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1024px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:table-cell{
    display: table-cell;
  }

  .lg\\:w-\\[480px\\]{
    width: 480px;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:p-12{
    padding: 3rem;
  }

  .lg\\:text-left{
    text-align: left;
  }
}

@media (min-width: 1280px){

  .xl\\:table-cell{
    display: table-cell;
  }

  .xl\\:w-\\[520px\\]{
    width: 520px;
  }
}

.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,2BAAc;EAAA;;AAAd;IAAA,2BAAc;IAAd,0BAAc;IAAd,2EAAc;IAAd,eAAc;IAAd,gBAAc;IAAd,mCAAc;IAAd,kCAAc;EAAA;;AAAd;IAAA,kCAAc;IAAd,0BAAc;IAAd,gBAAc;EAAA;;AAAd,KAAA,mBAAc,EAAd,gBAAc,EAAA;;AAAd,KAAA,iBAAc,EAAd,gBAAc,EAAA;;AAAd,KAAA,kBAAc,EAAd,gBAAc,EAAA;;AAAd,KAAA,mBAAc,EAAd,gBAAc,EAAA;;AAAd,4CAAc;;AAAd;IAAA,KAAA,mBAAc,EAAA;IAAd,KAAA,mBAAc,EAAA;IAAd,KAAA,mBAAc,EAAA;EAAA;;AAAd,8BAAA,4BAAc,EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;gFAEgF;;AAEhF;EACE,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;;EAEvB,oDAAoD;EACpD,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;;EAErB,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;;EAEvB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,sCAAsC;;EAEtC,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;;EAE1C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,8BAA8B;EAC9B,iBAAiB;;EAEjB,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;EAC1B,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,kCAAkC;EAClC,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;gFAEgF;;AAEhF;EACE,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;EACnB;AACF;;AAoCA;;gFAEgF;;AAEhF,UAAU;AACV;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;EACzC,6EAA6E;AAC/E;;AAEA;EACE,iCAAiC;EACjC,yEAAyE;EACzE,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;EACzC,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,2EAA2E;AAC7E;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,6EAA6E;AAC/E;;AAEA;EACE,gCAAgC;EAChC,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB,mBAAmB,mCAAmC,EAAE;AACxD,cAAc,qCAAqC,EAAE;AACrD,gBAAgB,qCAAqC,EAAE;AACvD,aAAa,oCAAoC,EAAE;;AAEnD,kBAAkB;AAClB;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;;gFAEgF;;AAEhF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,sCAAsC;EACtC,wDAAwD;EACxD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;;EAEE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;gFAEgF;;AAEhF;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;;gFAEgF;;AAEhF,yCAAyC;AACzC;EACE,WAAW,sEAAsE,EAAE;EACnF,YAAY,sEAAsE,EAAE;AACtF;AACA;EACE,WAAW,wEAAwE,EAAE;EACrF,YAAY,uEAAuE,EAAE;AACvF;AACA,sBAAsB,uDAAuD,EAAE;AAC/E,sBAAsB,uDAAuD,EAAE;;AAE/E;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;gFAEgF;;AAEhF;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW,+BAA+B,EAAE,6CAA6C,EAAE;EAC3F,MAAM,yCAAyC,EAAE,gBAAgB,EAAE;AACrE;;AAEA,yBAAyB,8CAA8C,EAAE;AACzE,mBAAmB,yCAAyC,EAAE;AAC9D,YAAY,wCAAwC,EAAE;AACtD,mBAAmB,+CAA+C,EAAE;;AAEpE,uBAAuB;AACvB,qBAAqB,OAAO,2BAA2B,EAAE,UAAU,EAAE,EAAE,KAAK,wBAAwB,EAAE,UAAU,EAAE,EAAE;AACpH,oBAAoB,8DAA8D,EAAE;;AAEpF;;gFAEgF;;AAEhF,wBAAwB,OAAO,uBAAuB,EAAE,EAAE,KAAK,yBAAyB,EAAE,EAAE;AAC5F,2BAA2B,OAAO,uBAAuB,EAAE,EAAE,KAAK,0BAA0B,EAAE,EAAE;AAChG;EACE,KAAK,uBAAuB,EAAE,UAAU,EAAE;EAC1C,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,yBAAyB,EAAE,UAAU,EAAE;AAChD;AACA;EACE,KAAK,sCAAsC,EAAE,UAAU,EAAE;EACzD,MAAM,YAAY,EAAE;EACpB,MAAM,YAAY,EAAE;EACpB,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,WAAW,gDAAgD,EAAE;EAC7D,MAAM,qDAAqD,EAAE;AAC/D;;AAEA,aAAa,yCAAyC,EAAE;AACxD,iBAAiB,4CAA4C,EAAE;AAC/D,oBAAoB,6CAA6C,EAAE;AACnE,eAAe,kEAAkE,EAAE;AACnF,YAAY,0CAA0C,EAAE;;AAExD;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;gFAEgF;;AAEhF,uBAAuB,qBAAqB,EAAE;AAC9C,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,qBAAqB,EAAE;AACvC,cAAc,mBAAmB,EAAE;AACnC,cAAc,wBAAwB,EAAE;;AAExC,cAAc,gCAAgC,EAAE;AAChD,uBAAuB,yCAAyC,EAAE;;AAElE,kBAAkB,2BAA2B,EAAE;AAC/C,gBAAgB,iCAAiC,EAAE;;AAEnD,uBAAuB;AACvB;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;;gFAEgF;;AAEhF;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;gFAEgF;;AA7dhF;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA;AAkeA;;AAleA;EAAA,mBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,mBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA,QAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA,iDAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kDAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,2BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,gDAkeA;EAleA,6DAkeA;EAleA;AAkeA;;AAleA;EAAA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,8BAkeA;EAleA;AAkeA;;AAleA;EAAA,2GAkeA;EAleA,yGAkeA;EAleA;AAkeA;;AAleA;EAAA,2GAkeA;EAleA,yGAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,8BAkeA;EAleA;AAkeA;;AAleA;EAAA,2GAkeA;EAleA,yGAkeA;EAleA;AAkeA;;AAleA;EAAA,2GAkeA;EAleA,yGAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,iBAkeA;EAleA,iBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,+EAkeA;EAleA,mGAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,yBAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,yBAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA;AAkeA;;AAleA;EAAA,gDAkeA;EAleA;AAkeA;;AAleA;EAAA,iDAkeA;EAleA;AAkeA;;AAleA;;EAAA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;AAAA;;AAleA;EAAA;AAkeA;;AAleA;;EAAA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;AAAA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,0EAkeA;EAleA,8FAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA,yBAkeA;EAleA,2BAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,+BAkeA;EAleA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA,yBAkeA;EAleA,2BAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,+BAkeA;EAleA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA,yBAkeA;EAleA,2BAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,+BAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,wBAkeA;EAleA,yBAkeA;EAleA,8BAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,wBAkeA;EAleA,yBAkeA;EAleA,8BAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,wBAkeA;EAleA,yBAkeA;EAleA,8BAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA,yBAkeA;EAleA,0BAkeA;EAleA,wBAkeA;EAleA,yBAkeA;EAleA,8BAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA,0BAkeA;EAleA,qBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,mBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;;EAAA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA,uBAkeA;IAleA,sDAkeA;IAleA;EAkeA;;EAleA;IAAA,uBAkeA;IAleA,oDAkeA;IAleA;EAkeA;;EAleA;IAAA,uBAkeA;IAleA,2DAkeA;IAleA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA,oBAkeA;IAleA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;AAAA;;AAleA;;EAAA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA,mBAkeA;IAleA;EAkeA;;EAleA;IAAA,mBAkeA;IAleA;EAkeA;AAAA;;AAleA;;EAAA;IAAA;EAkeA;;EAleA;IAAA,gBAkeA;IAleA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;AAAA;;AAleA;;EAAA;IAAA;EAkeA;;EAleA;IAAA;EAkeA;AAAA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,kDAkeA;EAleA;AAkeA;;AAleA;EAAA,iDAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,iDAkeA;EAleA;AAkeA;;AAleA;EAAA,kDAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kDAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA;AAkeA;;AAleA;EAAA,gBAkeA;EAleA,oBAkeA;EAleA,4BAkeA;EAleA;AAkeA;;AAleA;EAAA,sBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,WAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA,mBAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA,qBAkeA;EAleA;AAkeA;;AAleA;EAAA,kBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA,oBAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA,WAkeA;EAleA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA;;AAleA;EAAA;AAkeA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700&family=Manrope:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   THEME TOKENS - Slate Industrial (Option A)\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n:root {\n  /* Core Colors */\n  --bg: #0F1419;\n  --bg-darker: #0A0D10;\n  --surface: #1A2028;\n  --surface-hover: #232B35;\n  --surface-elevated: #242D38;\n  --border: #2D3748;\n  --border-light: #3D4A5C;\n  \n  /* Text — tuned for legibility on dark backgrounds */\n  --text-primary: #E8EAED;\n  --text-secondary: #C8D4E0;\n  --text-muted: #9BAFC0;\n  --text-faint: #7B8EA2;\n  \n  /* Primary Accent (Blue) */\n  --primary: #3B82F6;\n  --primary-hover: #2563EB;\n  --primary-muted: rgba(59, 130, 246, 0.15);\n  --primary-text: #FFFFFF;\n  \n  /* Status Colors */\n  --success: #22C55E;\n  --success-muted: rgba(34, 197, 94, 0.15);\n  --warning: #F59E0B;\n  --warning-muted: rgba(245, 158, 11, 0.15);\n  --error: #EF4444;\n  --error-muted: rgba(239, 68, 68, 0.15);\n  --info: #3B82F6;\n  --info-muted: rgba(59, 130, 246, 0.15);\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.5);\n  \n  /* Border Radius */\n  --radius-sm: 4px;\n  --radius-md: 6px;\n  --radius-lg: 8px;\n  \n  /* Responsive Base Font Size */\n  --base-font: 16px;\n  \n  /* Shadcn tokens (mapped to our theme) */\n  --background: 210 22% 8%;\n  --foreground: 220 10% 92%;\n  --card: 215 20% 13%;\n  --card-foreground: 220 10% 92%;\n  --popover: 215 20% 13%;\n  --popover-foreground: 220 10% 92%;\n  --primary-hsl: 217 91% 60%;\n  --primary-foreground: 0 0% 100%;\n  --secondary: 215 20% 18%;\n  --secondary-foreground: 217 91% 60%;\n  --muted: 215 15% 15%;\n  --muted-foreground: 215 20% 68%;\n  --accent: 215 20% 18%;\n  --accent-foreground: 217 91% 60%;\n  --destructive: 0 72% 51%;\n  --destructive-foreground: 0 0% 98%;\n  --border-hsl: 215 20% 25%;\n  --input: 215 20% 25%;\n  --ring: 217 91% 60%;\n  --radius: 0.375rem;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   RESPONSIVE TYPOGRAPHY & SPACING\n   ═══════════════════════════════════════════════════════════════════════════ */\n\nhtml {\n  font-size: var(--base-font);\n}\n\n/* Small laptops (1366x768 and below) */\n@media (max-width: 1366px) {\n  :root {\n    --base-font: 15px;\n  }\n}\n\n/* Larger screens */\n@media (min-width: 1920px) {\n  :root {\n    --base-font: 17px;\n  }\n}\n\n@layer base {\n  * {\n    border-color: var(--border);\n  }\n  \n  body {\n    background-color: var(--bg);\n    color: var(--text-primary);\n    font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n    font-size: 1rem;\n    line-height: 1.6;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  \n  h1, h2, h3, h4, h5, h6 {\n    font-family: 'Manrope', sans-serif;\n    color: var(--text-primary);\n    line-height: 1.3;\n  }\n  \n  h1 { font-size: 1.875rem; font-weight: 700; }\n  h2 { font-size: 1.5rem; font-weight: 700; }\n  h3 { font-size: 1.25rem; font-weight: 600; }\n  h4 { font-size: 1.125rem; font-weight: 600; }\n  \n  /* Responsive headings for smaller screens */\n  @media (max-width: 1366px) {\n    h1 { font-size: 1.625rem; }\n    h2 { font-size: 1.375rem; }\n    h3 { font-size: 1.125rem; }\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   COMPONENT STYLES\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n/* Cards */\n.card-slate {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.card-slate:hover {\n  border-color: var(--border-light);\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.55), 0 0 0 1px var(--border-light);\n  transform: translateY(-1px);\n}\n\n/* Legacy support - map old class to new */\n.card-industrial {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.card-industrial:hover {\n  border-color: var(--primary);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5), 0 0 12px rgba(59, 130, 246, 0.1);\n}\n\n/* Buttons */\n.btn-primary {\n  background: var(--primary);\n  color: var(--primary-text);\n  font-weight: 600;\n  padding: 0.75rem 1.25rem;\n  min-height: 44px;\n  border-radius: var(--radius-md);\n  transition: background 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;\n}\n\n.btn-primary:hover {\n  background: var(--primary-hover);\n  box-shadow: 0 0 18px rgba(59, 130, 246, 0.5), 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.btn-primary:active {\n  transform: scale(0.98);\n  box-shadow: 0 0 8px rgba(59, 130, 246, 0.3);\n}\n\n/* Status Strips */\n.strip-emergency { border-left: 4px solid var(--error); }\n.strip-high { border-left: 4px solid var(--warning); }\n.strip-medium { border-left: 4px solid var(--primary); }\n.strip-low { border-left: 4px solid var(--border); }\n\n/* Status Badges */\n.badge-success {\n  background: var(--success-muted);\n  color: var(--success);\n  border: 1px solid var(--success);\n  box-shadow: 0 0 8px rgba(87, 235, 49, 0.18);\n}\n\n.badge-warning {\n  background: var(--warning-muted);\n  color: var(--warning);\n  border: 1px solid var(--warning);\n  box-shadow: 0 0 8px rgba(245, 158, 11, 0.18);\n}\n\n.badge-error {\n  background: var(--error-muted);\n  color: var(--error);\n  border: 1px solid var(--error);\n  box-shadow: 0 0 8px rgba(239, 68, 68, 0.18);\n}\n\n.badge-info {\n  background: var(--info-muted);\n  color: var(--info);\n  border: 1px solid var(--info);\n  box-shadow: 0 0 8px rgba(59, 130, 246, 0.18);\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   TABLE STYLES (Comfortable by Default)\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.table-comfortable th {\n  padding: 1rem 1.25rem;\n  font-size: 0.76rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n  background: var(--bg-darker);\n  border-bottom: 1px solid var(--border);\n  text-align: left;\n}\n\n.table-comfortable td {\n  padding: 1rem 1.25rem;\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n  transition: background 0.12s ease, box-shadow 0.12s ease;\n  text-align: left;\n  vertical-align: middle;\n}\n\n/* Right-align numeric columns when explicitly tagged */\n.table-comfortable th.num,\n.table-comfortable td.num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Center-align utility (e.g. status pills) */\n.table-comfortable th.center,\n.table-comfortable td.center {\n  text-align: center;\n}\n\n.table-comfortable tbody tr:hover td {\n  background: var(--surface-hover);\n}\n\n.table-comfortable tbody tr:hover td:first-child {\n  box-shadow: inset 2px 0 0 var(--primary);\n}\n\n/* Compact variant (optional) */\n.table-compact th {\n  padding: 0.625rem 1rem;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  text-align: left;\n}\n\n.table-compact td {\n  padding: 0.625rem 1rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  text-align: left;\n  vertical-align: middle;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   FORM ELEMENTS\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.input-slate {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 0.75rem 1rem;\n  min-height: 44px;\n  font-size: 0.9375rem;\n  color: var(--text-primary);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.input-slate:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-muted);\n}\n\n.input-slate::placeholder {\n  color: var(--text-faint);\n}\n\n/* Select */\n.select-slate {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 0.75rem 1rem;\n  min-height: 44px;\n  font-size: 0.9375rem;\n  color: var(--text-primary);\n}\n\n.select-slate:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   SCROLLBAR\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n/* Pulse ring — for alert/overdue cards */\n@keyframes ring-pulse-error {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5), 0 4px 16px rgba(0,0,0,0.4); }\n  60%       { box-shadow: 0 0 0 7px rgba(239, 68, 68, 0), 0 4px 16px rgba(0,0,0,0.4); }\n}\n@keyframes ring-pulse-warning {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.45), 0 4px 16px rgba(0,0,0,0.4); }\n  60%       { box-shadow: 0 0 0 7px rgba(245, 158, 11, 0), 0 4px 16px rgba(0,0,0,0.4); }\n}\n.ring-pulse-error   { animation: ring-pulse-error   2.2s ease-in-out infinite; }\n.ring-pulse-warning { animation: ring-pulse-warning 2.2s ease-in-out infinite; }\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-darker);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--border-light);\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   ANIMATIONS\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n@keyframes fadeSlideIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n@keyframes pulseError {\n  0%, 100% { border-left-color: var(--error); box-shadow: -3px 0 8px rgba(239, 68, 68, 0.3); }\n  50% { border-left-color: rgba(239, 68, 68, 0.4); box-shadow: none; }\n}\n\n.animate-fade-slide-in { animation: fadeSlideIn 0.35s ease-out forwards; }\n.animate-fade-in { animation: fadeIn 0.25s ease-out forwards; }\n.live-dot { animation: pulse 2s ease-in-out infinite; }\n.emergency-strip { animation: pulseError 1.8s ease-in-out infinite; }\n\n/* PWA Install Prompt */\n@keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }\n.animate-slide-up { animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   LOGIN PAGE ANIMATIONS\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n@keyframes tireRotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }\n@keyframes tireRotateRev { from { transform: rotate(0deg); } to { transform: rotate(-360deg); } }\n@keyframes lightSweep {\n  0% { transform: rotate(0deg); opacity: 0; }\n  5% { opacity: 1; }\n  18% { opacity: 0; }\n  100% { transform: rotate(360deg); opacity: 0; }\n}\n@keyframes grainFloat {\n  0% { transform: translateY(0) translateX(0); opacity: 0; }\n  15% { opacity: 0.6; }\n  85% { opacity: 0.2; }\n  100% { transform: translateY(-80px) translateX(20px); opacity: 0; }\n}\n@keyframes cardReveal {\n  from { opacity: 0; transform: translateX(24px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n@keyframes hubGlow {\n  0%, 100% { filter: drop-shadow(0 0 0 rgba(59, 130, 246, 0)); }\n  50% { filter: drop-shadow(0 0 25px rgba(59, 130, 246, 0.3)); }\n}\n\n.tire-spin { animation: tireRotate 30s linear infinite; }\n.tire-spin-rev { animation: tireRotateRev 80s linear infinite; }\n.light-sweep-anim { animation: lightSweep 7s ease-in-out infinite; }\n.card-reveal { animation: cardReveal 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards; }\n.hub-glow { animation: hubGlow 4s ease-in-out infinite; }\n\n@media (prefers-reduced-motion: reduce) {\n  .tire-spin, .tire-spin-rev, .light-sweep-anim, .live-dot, .emergency-strip {\n    animation: none !important;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   UTILITY CLASSES\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.text-primary-accent { color: var(--primary); }\n.text-success { color: var(--success); }\n.text-warning { color: var(--warning); }\n.text-error { color: var(--error); }\n.text-muted { color: var(--text-muted); }\n\n.bg-surface { background-color: var(--surface); }\n.bg-surface-elevated { background-color: var(--surface-elevated); }\n\n.border-default { border-color: var(--border); }\n.border-light { border-color: var(--border-light); }\n\n/* Focus ring utility */\n.focus-ring:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--primary-muted);\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   RESPONSIVE SPACING UTILITIES\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.page-padding {\n  padding: 1.5rem;\n}\n\n@media (min-width: 1280px) {\n  .page-padding {\n    padding: 2rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .page-padding {\n    padding: 2.5rem;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   DEBUG WRAPPER (keep for compatibility)\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n@layer base {\n  [data-debug-wrapper=\"true\"] { display: contents !important; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
